<template>
  <div class="w-full flex justify-center">
    <GRecaptcha ref="gRecaptchaRef" @successCallback="recaptchaSuccess"></GRecaptcha>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useFormStore } from '@/stores/form'
import GRecaptcha from '@/components/GRecaptcha/index.vue'

const gRecaptchaRef = ref()
const formStore = useFormStore()

const recaptchaSuccess = (args) => {
  formStore.extraMap.recaptchaResponse = args
}
</script>

<style lang="scss" scoped></style>
